import React, { useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {
  Avatar,
  Box,
  Grid,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { poppins400, poppins500 } from 'theme/common.style';
import { highStarStyle } from 'modules/private/ViewDashBoardDetails/ViewDashboardDetails.style';
import { HighStar } from 'modules/private/ViewDashBoardDetails/ViewDashboardDetails';
import { Dot, GreenDot, Clock } from './Marketplaceicons';
import kiel from 'assets/images/kiel.png';
import PropertyTimer, { PauseIcon } from 'component/PropertyTime/PropertyTimer';
import { useState } from 'react';
import { MakeOffers } from './MakeOffers';
import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import moment from 'moment';
import userIcon from 'assets/svg/userIcon.png';

const FocusIcon = () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 0L24.002 6.124C27.5264 6.56958 30.8025 8.17486 33.3143 10.687C35.8261 13.1992 37.4309 16.4755 37.876 20H44V24L37.876 24.002C37.4305 27.5261 35.8255 30.802 33.3138 33.3138C30.802 35.8255 27.5261 37.4305 24.002 37.876L24 44H20V37.876C16.4755 37.4309 13.1992 35.8261 10.687 33.3143C8.17486 30.8025 6.56958 27.5264 6.124 24.002L0 24V20H6.124C6.56917 16.4752 8.17427 13.1987 10.6865 10.6865C13.1987 8.17427 16.4752 6.56917 20 6.124V0H24ZM22 10C18.8174 10 15.7652 11.2643 13.5147 13.5147C11.2643 15.7652 10 18.8174 10 22C10 25.1826 11.2643 28.2348 13.5147 30.4853C15.7652 32.7357 18.8174 34 22 34C25.1826 34 28.2348 32.7357 30.4853 30.4853C32.7357 28.2348 34 25.1826 34 22C34 18.8174 32.7357 15.7652 30.4853 13.5147C28.2348 11.2643 25.1826 10 22 10ZM22 18C23.0609 18 24.0783 18.4214 24.8284 19.1716C25.5786 19.9217 26 20.9391 26 22C26 23.0609 25.5786 24.0783 24.8284 24.8284C24.0783 25.5786 23.0609 26 22 26C20.9391 26 19.9217 25.5786 19.1716 24.8284C18.4214 24.0783 18 23.0609 18 22C18 20.9391 18.4214 19.9217 19.1716 19.1716C19.9217 18.4214 20.9391 18 22 18Z"
        fill="black"
      />
    </svg>
  );
};
const CloseIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.292787 1.29357C0.480314 1.1061 0.734622 1.00078 0.999786 1.00078C1.26495 1.00078 1.51926 1.1061 1.70679 1.29357L6.99979 6.58657L12.2928 1.29357C12.385 1.19806 12.4954 1.12188 12.6174 1.06947C12.7394 1.01706 12.8706 0.989473 13.0034 0.988319C13.1362 0.987165 13.2678 1.01247 13.3907 1.06275C13.5136 1.11303 13.6253 1.18728 13.7192 1.28117C13.8131 1.37507 13.8873 1.48672 13.9376 1.60962C13.9879 1.73251 14.0132 1.86419 14.012 1.99697C14.0109 2.12975 13.9833 2.26097 13.9309 2.38297C13.8785 2.50498 13.8023 2.61532 13.7068 2.70757L8.41379 8.00057L13.7068 13.2936C13.8889 13.4822 13.9897 13.7348 13.9875 13.997C13.9852 14.2592 13.88 14.51 13.6946 14.6954C13.5092 14.8808 13.2584 14.986 12.9962 14.9882C12.734 14.9905 12.4814 14.8897 12.2928 14.7076L6.99979 9.41457L1.70679 14.7076C1.51818 14.8897 1.26558 14.9905 1.00339 14.9882C0.741188 14.986 0.490376 14.8808 0.304968 14.6954C0.11956 14.51 0.0143906 14.2592 0.0121121 13.997C0.00983372 13.7348 0.110629 13.4822 0.292787 13.2936L5.58579 8.00057L0.292787 2.70757C0.105316 2.52004 0 2.26573 0 2.00057C0 1.73541 0.105316 1.4811 0.292787 1.29357Z"
        fill="#0D0D0D"
      />
    </svg>
  );
};
const containerStyle = {
  position: 'relative',
  display: 'inline-block',
};

const textStyle = {
  visibility: 'hidden',
  backgroundColor: '#fff',
  color: '#000',
  textAlign: 'center',
  borderRadius: '6px',
  padding: '5px 10px',
  position: 'absolute',
  zIndex: 1,
  bottom: '125%',
  left: '50%',
  transform: 'translateX(-50%)',
  whiteSpace: 'nowrap',
  boxShadow: '8px 8px 8px 8px rgba(0, 0, 0, 0.1)',
  fontFamily: 'Poppins',
  fontSize: '10px',
};
const textVisibleStyle = {
  ...textStyle,
  visibility: 'visible',
  opacity: 1,
  transition: 'opacity 0.3s',
};

const containerConditionalStyle = {
  position: 'relative',
  display: 'inline-block',
};
const textConditionalStyle = {
  visibility: 'hidden',
  backgroundColor: '#fff',
  color: '#000',
  textAlign: 'center',
  borderRadius: '6px',
  padding: '15px 10px',
  position: 'absolute',
  zIndex: 1,
  bottom: '125%',
  left: '50%',
  transform: 'translateX(-50%)',
  whiteSpace: 'nowrap',
  boxShadow: '8px 8px 8px 8px rgba(0, 0, 0, 0.1)',
  fontFamily: 'Poppins',
  fontSize: '10px',
};

const FocusModePopup = (props) => {
  const {
    isAuction,
    auctionDetails,
    open,
    handleCloseFocus,
    getBuyerIndividualValue,
    dateupdated,
    setShowActivateTrade,
    setHideActivateTrade,

    tabData,
    offerHistoryState,
    sharedpage,
    openlogin,
    setOpenlogin,
    groupCall,
    groupIt,
    groupcallData,

    setTabDAta,
    setNewTabData,
    setShowPropertyTimer,
    hideOthers,
    SetHideOthers,
    hideActivateTrade,
    makeOfferRef,
    confirmAcceptLog,

    setDontallowtooffer,
    isFirstOffer,
    st1condition,
    st2condition,
    doc66wstatus,
    array,
    withdrawLeftCount,
    setLastHighestOffers,
    lastHighestOffers,
    makeOfferListArray,
    isFocusMode,
    offersOnly,
    setOffersOnly,
    checkListArray,
    isStageTwoRequested,
    setIsStageTwoRequested,
    getlistMakeOffer,
    focusModeActionTabSwitching,
    directcomm,
    lastLatestOffer,
    setOpensolicitorpopup,
    setTypeofsolicitorpopup,
  } = props;

  const stage = getBuyerIndividualValue?.PropertyDetails?.stage;
  const [dateTimeAfterThreeDays, setdateTimeAfterThreeDays] = useState(0);
  const [pause, SetPause] = useState();

  const propertyData = getBuyerIndividualValue?.PropertyDetails;

  const [progress, setProgress] = useState({
    time: 0,
    remainingHoursTime: 0,
  });

  const yourLastOfferUpdate = moment(
    getBuyerIndividualValue?.PropertyDetails?.yourOfferUpdated
  ).format('DD-MM-YYYY');

  useEffect(() => {
    const interval = setInterval(() => {
      var totalTimeMillis = moment(
        dateTimeAfterThreeDays,
        'YYYY-MM-DD HH:mm:ss:SSS'
      ).diff(moment(propertyData?.startedAt, 'YYYY-MM-DD HH:mm:ss:SSS'));
      var remainingMillis = moment(
        new Date(
          new Date().toLocaleString('en-US', { timeZone: 'Australia/Sydney' })
        ).getTime()
      ).diff(moment(propertyData?.startedAt, 'YYYY-MM-DD HH:mm:ss:SSS'));
      var time = Math.floor(
        isNaN(remainingMillis)
          ? 100
          : (1 - remainingMillis / totalTimeMillis) * 100
      );

      const remainingHoursTime = totalTimeMillis
        ? (totalTimeMillis - remainingMillis) / (60 * 60 * 1000)
        : 0;
      setProgress({ time, remainingHoursTime });
    }, 1000);

    return () => clearInterval(interval);
  }, [propertyData, dateTimeAfterThreeDays]);

  const determineGradient = (remainingTime, stage) => {
    if (remainingTime <= 0 || isNaN(remainingTime)) {
      return '#E2E0E0';
    }
    if (
      (stage == 'ST1' && remainingTime <= 3 * 24) ||
      (stage == 'ST2' && remainingTime <= 3)
    ) {
      return 'linear-gradient(180deg, #F93939 0%, #F8B4B4 100%)';
    }
    return 'linear-gradient(180deg, #6D3BD6 0%, #6F5BDF 25.21%, #74A8F3 85.1%, #74B2F6 92.92%, #75BBF8 100%)';
  };

  const BorderLinearProgress = styled(LinearProgress)(
    ({ theme, gradientColor }) => ({
      height: 15,
      width: 'auto',
      position: 'relative',
      [`&.${linearProgressClasses.colorPrimary}`]: {
        background: '#FAFAFA',
        borderRadius: 20,
        borderColor: '#6C2AD2',
      },
      [`& .${linearProgressClasses.bar}`]: {
        background: gradientColor,
        borderRadius: 2.42,
        transition: 'none',
      },
    })
  );

  function LinearProgressBar(props) {
    const rediness = props.rediness || 0;
    const value = Number(props?.value) || 0;
    const gradientColor = props.gradientColor;
    return (
      <div style={{ position: 'relative' }}>
        <BorderLinearProgress
          variant="determinate"
          value={value}
          gradientColor={gradientColor}
        />
      </div>
    );
  }

  useEffect(() => {
    if (propertyData?.stage !== 0 && propertyData?.timerStatus === 'Start') {
      const currentTime = moment().valueOf();
      const dateWithStartAtCal = moment(propertyData?.startedAt).format();
      const duration = moment.duration(
        propertyData?.timerDuration,
        'milliseconds'
      );

      const runningDate = moment(dateWithStartAtCal).add(duration).toDate();
      setdateTimeAfterThreeDays(runningDate);
    } else if (
      propertyData?.stage !== 0 &&
      propertyData?.timerStatus === 'Pause'
    ) {
      SetPause(propertyData?.pausedTimerDuration);
      const currentTime = moment().valueOf();
      const dateWithStartAtCal = moment(propertyData?.startedAt).format();
      const duration = moment.duration(
        propertyData?.timerDuration,
        'milliseconds'
      );
      const runningDate = moment(dateWithStartAtCal).add(duration).toDate();
      setdateTimeAfterThreeDays(runningDate);
    } else {
      const dateWithStartAtCal = moment(propertyData?.startedAt).format();
      const runningDate = moment(dateWithStartAtCal).toDate();
      setdateTimeAfterThreeDays(runningDate);
    }
  }, [propertyData]);

  const data1 = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data1);
  const buyerId = userDetail?.userId;

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));

  const [isConditionalHoveredFirst, setIsConditionalHoveredFirst] =
    useState(false);
  const [isConditionalHoveredSecond, setIsConditionalHoveredSecond] =
    useState(false);
  const [isHoveredFirst, setIsHoveredFirst] = useState(false);
  const [isHoveredSecond, setIsHoveredSecond] = useState(false);

  useEffect(() => {
    let scrollY = 0;
    if (open) {
      scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overflow = 'hidden';
      document.body.style.width = '100%';
    }

    return () => {
      const top = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      document.body.style.width = '';
      if (top) {
        const savedScroll = parseInt(top || '0') * -1;
        window.scrollTo(0, savedScroll);
      }
    };
  }, [open]);

  return (
    <>
      <Dialog open={open} maxWidth={'xl'} fullWidth>
        <Box>
          {getBuyerIndividualValue?.PropertyDetails?.propertyAddress
            ?.streetName && (
            <Box
              sx={{
                background: '#FAFAFA',
                padding: '16px 35px 0 35px',
                textAlign: 'left',
                pl: '35px',
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins !important',
                  fontStyle: 'normal !important',
                  fontWeight: '500 !important',
                  fontSize: '14px',
                  color: '#666',
                }}
              >
                {
                  getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                    ?.streetName
                }
              </Typography>
            </Box>
          )}

          {/* Focus Heading below the address */}
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              background: '#FAFAFA',
              position: 'sticky',
              top: 0,
              zIndex: '1000',
              padding: '8px 35px 20px 35px',
            }}
          >
            <Stack
              direction={'row'}
              justifyContent={'space-between'}
              alignItems={'center'}
            >
              <Stack direction={'row'} spacing={2}>
                <FocusIcon />
                <Typography sx={{ ...poppins500, fontSize: '32px' }}>
                  Focus
                </Typography>
              </Stack>
              <Box>
                <IconButton onClick={handleCloseFocus}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Stack>
          </DialogTitle>
          <DialogContent sx={{ background: '#FAFAFA' }}>
            <Grid container spacing={1.7}>
              <Grid item xs={12} sm={4}>
                <Stack spacing={2}>
                  <Stack
                    sx={{
                      minWidth: '380px',
                      maxWidth: '474px',
                      height: 'auto',
                      backgroundColor: 'rgba(255, 255, 255, 0.77)',
                      borderRadius: '5px',
                      border: '0.5px solid #F0F0F0',
                    }}
                  >
                    <Stack
                      sx={{
                        marginLeft: '8px',
                        marginTop: '12px',
                        marginRight: '8px',
                        height: '59px',
                        background: '#F7F8F7',
                        padding: '10px 10px 10px 10px',
                        borderRadius: '6px',
                      }}
                    >
                      <Typography
                        sx={{
                          textAlign: 'start',
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '500 !important',
                          fontSize: '20px',
                          color: '#6C2AD2',
                        }}
                      >
                        Highest Offer
                      </Typography>
                    </Stack>

                    {getBuyerIndividualValue?.PropertyDetails?.highestOffer ? (
                      <Stack sx={{ paddingTop: '20px' }} gap={1}>
                        <Typography
                          sx={{
                            fontFamily: 'Poppins !important',
                            fontStyle: 'normal !important',
                            fontWeight: '500 !important',
                            fontSize: '30px',
                            color: '#112347',
                            textAlign: 'center',
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        >
                          {getBuyerIndividualValue?.PropertyDetails
                            ?.highestOfferIsFinal == 1 && (
                            <div
                              style={containerStyle}
                              onMouseEnter={() => setIsHoveredFirst(true)}
                              onMouseLeave={() => setIsHoveredFirst(false)}
                            >
                              <HighStar style={highStarStyle} />
                              <span
                                style={
                                  isHoveredFirst ? textVisibleStyle : textStyle
                                }
                              >
                                Best & Final Offer
                              </span>
                            </div>
                          )}{' '}
                          {`${
                            getBuyerIndividualValue?.PropertyDetails
                              ?.highestOffer || '-'
                          }`}
                          <sup>
                            {getBuyerIndividualValue?.PropertyDetails
                              ?.highestOfferIsConditional == 1 ? (
                              <div
                                style={containerConditionalStyle}
                                onMouseEnter={() =>
                                  setIsConditionalHoveredFirst(true)
                                }
                                onMouseLeave={() =>
                                  setIsConditionalHoveredFirst(false)
                                }
                              >
                                {getBuyerIndividualValue?.PropertyDetails
                                  ?.highestOfferBuyerCodeId ===
                                userDetail?.userAppId ? (
                                  <Dot />
                                ) : (
                                  ''
                                )}
                                <span
                                  style={
                                    isConditionalHoveredFirst
                                      ? textVisibleStyle
                                      : textConditionalStyle
                                  }
                                >
                                  Conditional
                                </span>
                              </div>
                            ) : getBuyerIndividualValue?.PropertyDetails
                                ?.highestOfferBuyerCodeId ===
                              userDetail?.userAppId ? (
                              <GreenDot />
                            ) : (
                              ''
                            )}
                          </sup>
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: 'Poppins !important',
                            fontStyle: 'normal !important',
                            fontWeight: '400 !important',
                            fontSize: '12px',
                            color: 'rgba(17, 35, 71, 0.5)',

                            textAlign: 'center',
                          }}
                        >
                          Last Updated : &nbsp;
                          {dateupdated}
                        </Typography>

                        <Typography
                          sx={{
                            fontFamily: 'Poppins !important',
                            fontStyle: 'normal !important',
                            fontWeight: '300 !important',
                            fontSize: '16px',
                            color: '#112347',
                            marginTop: '3.33px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '7px',
                          }}
                        >
                          {getBuyerIndividualValue?.PropertyDetails
                            ?.highestOfferBuyerCodeId ===
                          userDetail?.userAppId ? (
                            userDetail?.profileImage == '' ||
                            userDetail?.profileImage == null ? (
                              <Avatar
                                height={'36.5px'}
                                width={'36.5px'}
                                style={{
                                  marginTop: '12px',
                                  fontSize: '15px',
                                  fontFamily: 'poppins',
                                  borderRadius: '6px',
                                  backgroundColor: '#666666',
                                  spacing: '1',
                                }}
                              >
                                {userDetail?.userName?.charAt(0).toUpperCase()}
                                {userDetail?.userSurName
                                  ?.charAt(0)
                                  .toUpperCase()}
                              </Avatar>
                            ) : (
                              <Avatar
                                src={userDetail?.profileImage}
                                height={'36.5px'}
                                width={'36.5px'}
                                style={{
                                  marginTop: '12px',

                                  spacing: '1',
                                }}
                              />
                            )
                          ) : (
                            <Avatar
                              src={userIcon}
                              height={'36.5px'}
                              width={'36.5px'}
                              style={{
                                marginTop: '12px',

                                spacing: '1',
                              }}
                            />
                          )}{' '}
                          <Typography
                            sx={{
                              fontFamily: 'Poppins !important',
                              fontStyle: 'normal !important',
                              fontWeight: '300 !important',
                              fontSize: '16px',
                              color: '#112347',
                              marginTop: '11.33px',
                            }}
                          >
                            {getBuyerIndividualValue?.PropertyDetails
                              ?.highestOfferBuyerCodeId ===
                            userDetail?.userAppId
                              ? getBuyerIndividualValue?.PropertyDetails
                                  ?.highestOfferBuyerName
                              : getBuyerIndividualValue?.PropertyDetails
                                  ?.stage == 'ST2'
                              ? getBuyerIndividualValue?.PropertyDetails
                                  ?.highestOfferBuyerCodeId + ' (Not You)'
                              : getBuyerIndividualValue?.PropertyDetails
                                  ?.highestOfferUniqueId + ' (Not You)'}
                          </Typography>
                        </Typography>
                      </Stack>
                    ) : (
                      <Typography
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '300 !important',
                          fontSize: '16px',
                          color: '#112347',
                          padding: '60px',
                          mt: '10px',
                          textAlign: 'center',
                        }}
                      >
                        Not available
                      </Typography>
                    )}
                    <Grid
                      item
                      sx={{
                        borderRadius: '5px',
                        backgroundColor: 'rgba(255, 255, 255, 0.77)',
                        marginTop: !matcheslg && '15px',
                        p: '15px',
                        justifyContent: 'space-between',
                        opacity: '1',
                      }}
                    >
                      <Grid
                        sx={{
                          height: '17%',
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                          }}
                        >
                          <Clock />
                          <Typography
                            sx={{
                              fontFamily: 'Poppins !important',
                              fontStyle: 'normal !important',
                              fontWeight: '500 !important',
                              fontSize: '16px',
                              color: '#212529',
                              marginLeft: '11px',
                            }}
                          >
                            Offers close in:
                          </Typography>
                        </Box>
                        <Grid
                          sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            gap: '2px',
                          }}
                        >
                          {getBuyerIndividualValue?.PropertyDetails
                            ?.timerStatus == 'Pause' && (
                            <Box sx={{ paddingTop: '6px' }}>
                              <PauseIcon width={21} height={21} />
                            </Box>
                          )}
                          <Typography
                            sx={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              textAlign: 'center',
                              height: '20px',
                              margin: '7px',
                              padding: '3px 12px',
                              fontFamily: 'Poppins !important',
                              fontStyle: 'normal !important',
                              fontWeight: '600 !important',
                              fontSize: '12px',
                              color: '#FFFFFF',
                              borderRadius: '2px',
                              bgcolor:
                                getBuyerIndividualValue?.PropertyDetails
                                  ?.timerStatus == 'End'
                                  ? '#585858'
                                  : getBuyerIndividualValue?.PropertyDetails
                                      ?.stage === 'ST2'
                                  ? '#F93939'
                                  : getBuyerIndividualValue?.PropertyDetails
                                      ?.stage === 'ST1'
                                  ? '#10D35E'
                                  : getBuyerIndividualValue?.PropertyDetails
                                      ?.property?.status == 'Sold'
                                  ? '#F93939'
                                  : '#529AEE',
                            }}
                          >
                            {getBuyerIndividualValue?.PropertyDetails
                              ?.timerStatus == 'End'
                              ? 'ENDED'
                              : getBuyerIndividualValue?.PropertyDetails
                                  ?.stage == 'ST1'
                              ? 'STAGE 1'
                              : getBuyerIndividualValue?.PropertyDetails
                                  ?.stage == 'ST2'
                              ? getBuyerIndividualValue?.PropertyDetails
                                  ?.isReset == '1'
                                ? 'STAGE 2 - FINAL OFFERS'
                                : 'STAGE 2'
                              : getBuyerIndividualValue?.PropertyDetails
                                  ?.property?.status == 'Sold'
                              ? 'Sold'
                              : 'Unpublished'}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Box
                        sx={{
                          marginTop: '10px',
                          minWidth: '100%',
                          padding: '0 30px',
                          gap: 15,
                        }}
                      >
                        <div>
                          <PropertyTimer
                            propertyData={
                              getBuyerIndividualValue?.PropertyDetails
                            }
                            isReset={
                              getBuyerIndividualValue?.PropertyDetails?.isReset
                            }
                            upperCountDown={'upperCountDown'}
                          />
                        </div>
                        <div style={{ marginTop: 10 }}>
                          <LinearProgressBar
                            value={progress.time}
                            gradientColor={determineGradient(
                              progress.remainingHoursTime,
                              stage
                            )}
                          />
                        </div>
                      </Box>
                    </Grid>
                  </Stack>
                  <Stack
                    sx={{
                      minWidth: '380px',
                      maxWidth: '474px',
                      height: '251px',
                      backgroundColor: 'rgba(255, 255, 255, 0.77)',
                      borderRadius: '5px',
                      border: '0.5px solid #F0F0F0',
                    }}
                  >
                    <Stack
                      sx={{
                        marginLeft: '8px',
                        marginTop: '12px',
                        marginRight: '8px',
                        height: '59px',
                        background: '#F7F8F7',
                        borderRadius: '6px',
                        padding: '10px 10px 10px 10px',
                        borderRadius: '6px',
                      }}
                    >
                      <Typography
                        sx={{
                          textAlign: 'start',
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '500 !important',
                          fontSize: '20px',
                          color: '#6C2AD2',
                        }}
                      >
                        Your Last Offer
                      </Typography>
                    </Stack>

                    {getBuyerIndividualValue?.PropertyDetails?.highestOffer &&
                    getBuyerIndividualValue?.PropertyDetails?.offerStatus
                      ?.price !== '' ? (
                      <Stack
                        sx={{ padding: '20px' }}
                        gap={1}
                        alignItems={'center'}
                      >
                        <Typography
                          sx={{
                            ...poppins400,
                            visibility:
                              getBuyerIndividualValue?.PropertyDetails
                                ?.highestOfferBuyerCodeId ===
                              userDetail?.userAppId
                                ? 'hidden'
                                : 'inherit',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            textAlign: 'center',
                            width: '127px',
                            height: '20px',
                            margin: '7px',
                            padding: '3px 12px',
                            fontSize: '14px',
                            color: '#FFFFFF',
                            borderRadius: '2px',
                            bgcolor: '#F93939CC',
                          }}
                        >
                          OUT OFFERED
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: 'Poppins !important',
                            fontStyle: 'normal !important',
                            fontWeight: '500 !important',
                            fontSize: '30px',
                            color: '#112347',
                            textAlign: 'center',
                            mt: 1,
                            display: 'flex',
                            justifyContent: 'center',
                          }}
                        >
                          {getBuyerIndividualValue?.PropertyDetails
                            ?.highestOfferIsFinal === 1 && (
                            <div
                              style={containerStyle}
                              onMouseEnter={() => setIsHoveredSecond(true)}
                              onMouseLeave={() => setIsHoveredSecond(false)}
                            >
                              {getBuyerIndividualValue?.PropertyDetails
                                ?.offerStatus?.priceIsFinal !== 0 && (
                                <HighStar style={highStarStyle} />
                              )}
                              <span
                                style={
                                  isHoveredSecond ? textVisibleStyle : textStyle
                                }
                              >
                                Best & Final Offer
                              </span>
                            </div>
                          )}{' '}
                          {`${
                            getBuyerIndividualValue?.PropertyDetails
                              ?.offerStatus?.price || '-'
                          }`}
                          <sup>
                            {getBuyerIndividualValue?.PropertyDetails
                              ?.yourOfferCondition == 1 ? (
                              <div
                                style={containerConditionalStyle}
                                onMouseEnter={() =>
                                  setIsConditionalHoveredSecond(true)
                                }
                                onMouseLeave={() =>
                                  setIsConditionalHoveredSecond(false)
                                }
                              >
                                <Dot />
                                <span
                                  style={
                                    isConditionalHoveredSecond
                                      ? textVisibleStyle
                                      : textConditionalStyle
                                  }
                                >
                                  Conditional
                                </span>
                              </div>
                            ) : (
                              <GreenDot />
                            )}
                          </sup>
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: 'Poppins !important',
                            fontStyle: 'normal !important',
                            fontWeight: '400 !important',
                            fontSize: '12px',
                            color: 'rgba(17, 35, 71, 0.5)',

                            textAlign: 'center',
                          }}
                        >
                          Last Updated : &nbsp;
                          {yourLastOfferUpdate}
                        </Typography>
                      </Stack>
                    ) : (
                      <Typography
                        sx={{
                          fontFamily: 'Poppins !important',
                          fontStyle: 'normal !important',
                          fontWeight: '300 !important',
                          fontSize: '16px',
                          color: '#112347',
                          padding: '50px',
                          mt: '30px',
                          textAlign: 'center',
                        }}
                      >
                        No offer found
                      </Typography>
                    )}
                  </Stack>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={8}>
                <MakeOffers
                  isAuction={isAuction}
                  auctionDetails={auctionDetails}
                  setTabDAta={setTabDAta}
                  setNewTabData={setNewTabData}
                  setShowPropertyTimer={setShowPropertyTimer}
                  offerHistoryState={offerHistoryState}
                  tabData={tabData}
                  hideOthers={hideOthers}
                  SetHideOthers={SetHideOthers}
                  hideActivateTrade={hideActivateTrade}
                  setHideActivateTrade={setHideActivateTrade}
                  makeOfferListArray={makeOfferListArray}
                  lastHighestOffers={lastHighestOffers}
                  setLastHighestOffers={setLastHighestOffers}
                  withdrawLeftCount={withdrawLeftCount}
                  array={array}
                  setShowActivateTrade={setShowActivateTrade}
                  makeOfferRef={makeOfferRef}
                  stage={getBuyerIndividualValue?.PropertyDetails?.stage}
                  groupIt={groupIt}
                  getBuyerIndividualValue={getBuyerIndividualValue}
                  confirmAcceptLog={confirmAcceptLog}
                  setOpenlogin={setOpenlogin}
                  openlogin={openlogin}
                  sharedpage={sharedpage}
                  doc66wstatus={doc66wstatus}
                  st1condition={st1condition}
                  st2condition={st2condition}
                  isFirstOffer={isFirstOffer}
                  setDontallowtooffer={setDontallowtooffer}
                  isFocusMode={isFocusMode}
                  groupCall={groupCall}
                  offersOnly={offersOnly}
                  setOffersOnly={setOffersOnly}
                  checkListArray={checkListArray}
                  isStageTwoRequested={isStageTwoRequested}
                  setIsStageTwoRequested={setIsStageTwoRequested}
                  getlistMakeOffer={getlistMakeOffer}
                  handleCloseFocus={handleCloseFocus}
                  focusModeActionTabSwitching={focusModeActionTabSwitching}
                  directcomm={directcomm}
                  lastLatestOffer={lastLatestOffer}
                  setOpensolicitorpopup={setOpensolicitorpopup}
                  setTypeofsolicitorpopup={setTypeofsolicitorpopup}
                />
              </Grid>
            </Grid>
          </DialogContent>
        </Box>
      </Dialog>
    </>
  );
};

export default React.memo(FocusModePopup);
